import { cn } from "@/lib/utils";
import SettingsStore from "@/stores/SettingsStore";
import { motion } from "framer-motion";
import { Keyboard, Speech } from "lucide-react";

type TInputModeToggleProps = {
  inputMode: string;
  onToggle: () => void;
};

export default function InputModeToggle({ inputMode, onToggle }: TInputModeToggleProps) {
  const usePushToTalk = SettingsStore(state => state.usePushToTalk);
  return (
    <div
      className={cn(
        'cursor-pointer absolute bottom-0 rounded-full bg-slate-100',
        '',
        usePushToTalk ? 'left-full' : 'translate-x-[-50%]',
      )}
      onClick={onToggle}
      title={inputMode === 'voice' ? 'Wechsel zu Texteingabe' : 'Wechsel zu Spracheingabe'}
    >
      <motion.div className={"relative flex items-center p-1 justify-between h-14 w-24"} layout>
        <motion.div
          className={cn('absolute h-12 w-12 bg-white z-4 rounded-full pointer-events-none')}
          initial={false}
          animate={inputMode === 'voice' ? { x: 0 } : { x: 40 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          aria-hidden
        />
        <div
          className={cn(
            "h-6 w-6 relative z-5 ml-3",
            inputMode === "voice" ? "text-primary" : "text-gray-400"
          )}
        >
          <Speech
            strokeWidth={1.5}
          />
        </div>
        <div className={cn(
          "h-6 w-6 relative z-5 mr-3",
          inputMode === "text" ? "text-primary" : "text-gray-400"
        )}>
          <Keyboard
            strokeWidth={1.5}
          />
        </div>
      </motion.div>
    </div>
  );
}
